import React from 'react';
import TabbedFeaturesSelectorItem from './TabbedFeaturesSelectorItem';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import { TabbedFeaturesSelectorContainer } from './TabbedFeaturesSelector.styles';

interface TabbedFeaturesSelectorProps {
  tabs: {
    label: string;
    description?: string | React.ReactNode;
    active: boolean;
  }[];
  onTabClick: (index: number) => void;
}

const TabbedFeaturesSelector = ({ onTabClick, tabs }: TabbedFeaturesSelectorProps): JSX.Element => {
  return (
    <TabbedFeaturesSelectorContainer>
      <Grid
        totalColumns={tabs.length}
        className='tabbed-features-selector-grid'
        paddingSm={['spacing-none', 'spacing-xl']}
      >
        {tabs.map((tab, index) => (
          <TabbedFeaturesSelectorItem
            key={index}
            label={tab.label}
            description={tab.description}
            active={tab.active}
            onClick={() => onTabClick(index)}
          />
        ))}
      </Grid>
    </TabbedFeaturesSelectorContainer>
  );
};

export default TabbedFeaturesSelector;
